import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";
import { type ScrapedUser } from "@/lib/scraper";
import { Badge } from "@/components/ui/badge";

/**
 * UserFlags — unified user-flag badges (DESIGN-SYSTEM §1.2).
 * premium = accent, bot = neutral, deleted = danger. Shared by the Audience
 * table cell and the user DetailDrawer so the chips read identically.
 */
export function UserFlags({ user }: { user: ScrapedUser }) {
  const { t } = useTranslation();

  const hasAny = user.is_premium || user.is_bot || user.is_deleted;
  if (!hasAny) {
    return <span className="text-fg-muted">—</span>;
  }

  return (
    <div className="flex flex-wrap items-center gap-1">
      {user.is_premium && (
        <Badge
          tone="accent"
          icon={<Star size={12} strokeWidth={2} aria-hidden="true" />}
        >
          Premium
        </Badge>
      )}
      {user.is_bot && <Badge tone="neutral">{t("users.flag.bot")}</Badge>}
      {user.is_deleted && (
        <Badge tone="danger">{t("users.flag.deleted")}</Badge>
      )}
    </div>
  );
}
